export function boxOfficeLightbox() {
    const lightboxButton = document.querySelector('.box-office__link');
    const lightbox = document.querySelector('.box-office__lightbox');
    const closeButton = document.querySelector('.box-office__close');

    // Function to toggle the lightbox visibility
    function toggleLightbox() {
        if (lightbox.style.display === 'none' || lightbox.style.display === '') {
            lightbox.style.display = 'flex';
            document.body.classList.add('farlo-ui-lightbox--active');
        } else {
            lightbox.style.display = 'none';
            document.body.classList.remove('farlo-ui-lightbox--active');
        }
    }

    // Function to close the lightbox
    function closeLightbox() {
        lightbox.style.display = 'none';
        document.body.classList.remove('farlo-ui-lightbox--active');
    }

    // Event listener for the lightbox button
    lightboxButton.addEventListener('click', function(event) {
        event.preventDefault();
        toggleLightbox();
    });

    // Event listener for the close button
    closeButton.addEventListener('click', function() {
        closeLightbox();
    });
}